import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Versatile button-as-link with consistent brand styling.
 * variant: 'solid' | 'ghost' | 'outline' | 'light-outline'
 */
export default function CTA({
  to,
  href,
  onClick,
  variant = "solid",
  children,
  className = "",
  testid,
  type,
  arrow = true,
  disabled = false,
}) {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-[14px] font-medium tracking-tight transition-colors";
  const variants = {
    solid:
      "bg-brand-charcoal text-brand-off hover:bg-brand-dark disabled:opacity-50",
    "solid-light":
      "bg-brand-off text-brand-charcoal hover:bg-white disabled:opacity-50",
    ghost:
      "bg-transparent text-brand-charcoal hover:bg-brand-line/60",
    outline:
      "border border-brand-charcoal/15 text-brand-charcoal hover:border-brand-charcoal/40 hover:bg-white",
    "light-outline":
      "border border-white/25 text-brand-off hover:border-white/60 hover:bg-white/5",
    accent:
      "bg-brand-blue text-white hover:bg-brand-charcoal",
  };

  const content = (
    <>
      <span>{children}</span>
      {arrow && (
        <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      )}
    </>
  );

  const cls = cn(base, variants[variant], className);

  if (to) {
    return (
      <Link to={to} data-testid={testid} className={cls}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a
        href={href}
        target={href.startsWith("http") ? "_blank" : undefined}
        rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
        data-testid={testid}
        className={cls}
      >
        {content}
      </a>
    );
  }
  return (
    <button
      type={type || "button"}
      onClick={onClick}
      disabled={disabled}
      data-testid={testid}
      className={cls}
    >
      {content}
    </button>
  );
}
